import { render } from "./ConnectPatient.vue?vue&type=template&id=72a6fc96&scoped=true"
import script from "./ConnectPatient.vue?vue&type=script&lang=js"
export * from "./ConnectPatient.vue?vue&type=script&lang=js"

import "./ConnectPatient.vue?vue&type=style&index=0&id=72a6fc96&scoped=true&lang=scss"

import exportComponent from "H:\\ideaProject\\vue\\fiveG-project\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72a6fc96"]])

export default __exports__